import React, { useState } from 'react';

import CardDialog from '../../../CardDialog';
import LoadingIndicator from '../../../LoadingIndicator';
import ApprovalFinances from '../ApprovalsFinances';

import Filters from './Filters';

const PaymentApprovals = () => {
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(null);
  const [statuses] = useState(['pending_approval']);

  const handleChange = (key, values) => {
    setFilters((prevState) => ({ ...prevState, [key]: values }));
    setPage(0);
  };

  return (
    <CardDialog noCardTitle>
      <div className="p-20">
        <div>
          <Filters filters={filters} onChange={handleChange} />
        </div>
        <div>
          <ApprovalFinances
            filters={filters}
            statuses={statuses}
            page={page}
            setPage={setPage}
            onIsLoadingChanged={setIsLoading}
            onIsErrorChanged={setIsError}
          />
        </div>
        <div>{(isLoading || isError) && <LoadingIndicator isError={isError} />}</div>
      </div>
    </CardDialog>
  );
};

export default PaymentApprovals;
